async function GetAllConsultas() {
    // Detectamos si estamos en localhost
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    // Definimos la URL base según el entorno
    const API_URL = isLocalhost 
        ? 'http://localhost:4000' 
        : 'https://vetladradoc.uy';

    try {
        return await fetch(`${API_URL}/api/consulta/getAll`, {
            method: "POST", 
            body: JSON.stringify({}), 
            headers: {
                "Content-Type": "application/json"
            },
            // Vital para que Passport reconozca tu sesión en ambos entornos
            credentials: "include" 
        });
    } catch (error) {
        console.error("Error en la conexión con el servidor:", error);
        throw error;
    }
}

export default GetAllConsultas;